var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveLessonBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6324F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2701_37131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2701_37131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2701_37131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2701_37131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2701_37131)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2701_37131)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1041 11.6652C14.8385 11.6652 13.8124 12.6913 13.8124 13.9569C13.8124 15.2226 14.8385 16.2486 16.1041 16.2486C17.3698 16.2486 18.3958 15.2226 18.3958 13.9569C18.3958 12.6913 17.3698 11.6652 16.1041 11.6652ZM15.0624 13.9569C15.0624 13.3816 15.5288 12.9152 16.1041 12.9152C16.6794 12.9152 17.1458 13.3816 17.1458 13.9569C17.1458 14.5322 16.6794 14.9986 16.1041 14.9986C15.5288 14.9986 15.0624 14.5322 15.0624 13.9569Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1041 16.6652C15.1076 16.6652 14.1746 16.8659 13.4676 17.2194C12.7979 17.5542 12.1458 18.1324 12.1458 18.9569L12.1457 19.009C12.1444 19.4343 12.1422 20.1504 12.821 20.6417C13.1359 20.8697 13.5515 21.0151 14.0664 21.1077C14.5859 21.2012 15.2518 21.2486 16.1041 21.2486C16.9564 21.2486 17.6223 21.2012 18.1419 21.1077C18.6567 21.0151 19.0723 20.8697 19.3872 20.6417C20.066 20.1504 20.0638 19.4343 20.0625 19.009L20.0624 18.9569C20.0624 18.1324 19.4103 17.5542 18.7406 17.2194C18.0336 16.8659 17.1006 16.6652 16.1041 16.6652ZM13.3958 18.9569C13.3958 18.8609 13.4898 18.6058 14.0266 18.3374C14.526 18.0877 15.2596 17.9152 16.1041 17.9152C16.9486 17.9152 17.6822 18.0877 18.1816 18.3374C18.7184 18.6058 18.8124 18.8609 18.8124 18.9569C18.8124 19.4606 18.7804 19.5379 18.6543 19.6291C18.5526 19.7028 18.3432 19.8014 17.9205 19.8775C17.5026 19.9527 16.9185 19.9986 16.1041 19.9986C15.2898 19.9986 14.7056 19.9527 14.2877 19.8775C13.865 19.8014 13.6556 19.7028 13.5539 19.6291C13.4278 19.5379 13.3958 19.4606 13.3958 18.9569Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2863 8.7085H17.7137C19.2452 8.70848 20.4582 8.70847 21.4075 8.83611C22.3846 8.96747 23.1753 9.24423 23.799 9.86787C24.4226 10.4915 24.6994 11.2823 24.8307 12.2593C24.9584 13.2086 24.9584 14.4217 24.9584 15.9531V16.0472C24.9584 17.5786 24.9584 18.7917 24.8307 19.741C24.6994 20.718 24.4226 21.5088 23.799 22.1325C23.1753 22.7561 22.3846 23.0329 21.4075 23.1642C20.4582 23.2919 19.2452 23.2918 17.7137 23.2918H14.2863C12.7549 23.2918 11.5418 23.2919 10.5925 23.1642C9.61548 23.0329 8.82469 22.7561 8.20106 22.1325C7.57742 21.5088 7.30066 20.718 7.1693 19.741C7.04166 18.7917 7.04167 17.5787 7.04169 16.0472V15.9531C7.04167 14.4217 7.04166 13.2087 7.1693 12.2593C7.30066 11.2823 7.57742 10.4915 8.20106 9.86787C8.82469 9.24423 9.61548 8.96747 10.5925 8.83611C11.5418 8.70847 12.7549 8.70848 14.2863 8.7085ZM10.7591 10.075C9.92065 10.1877 9.43762 10.3991 9.08494 10.7517C8.73227 11.1044 8.52087 11.5875 8.40815 12.4259C8.29302 13.2823 8.29169 14.4111 8.29169 16.0002C8.29169 17.5892 8.29302 18.7181 8.40815 19.5745C8.52087 20.4129 8.73227 20.8959 9.08494 21.2486C9.43762 21.6013 9.92065 21.8126 10.7591 21.9254C11.6154 22.0405 12.7443 22.0418 14.3334 22.0418H17.6667C19.2557 22.0418 20.3846 22.0405 21.241 21.9254C22.0794 21.8126 22.5624 21.6013 22.9151 21.2486C23.2678 20.8959 23.4792 20.4129 23.5919 19.5745C23.707 18.7181 23.7084 17.5892 23.7084 16.0002C23.7084 14.4111 23.707 13.2823 23.5919 12.4259C23.4792 11.5875 23.2678 11.1044 22.9151 10.7517C22.5624 10.3991 22.0794 10.1877 21.241 10.075C20.3846 9.95982 19.2557 9.9585 17.6667 9.9585H14.3334C12.7443 9.9585 11.6154 9.95982 10.7591 10.075Z",
    fill: "#FAFAFA"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2701_37131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLessonBadge);
export default __webpack_public_path__ + "static/media/live-lesson-badge.95903f71e459f3be23fbec6745f34060.svg";
export { ForwardRef as ReactComponent };